export default __webpack_public_path__ + "static/media/rowers9.045a5d5b.jpg";